"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cart = void 0;

var _fetchJsonp = _interopRequireDefault(require("fetch-jsonp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cart = function cart(apiBase) {
  return (0, _fetchJsonp["default"])("".concat(apiBase, "/cart/cart.json"), {
    cache: "no-cache",
    credentials: "include"
  });
};

exports.cart = cart;